exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-media[data-v-f078e050] {\n  height: 300px;\n  width: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.title[data-v-f078e050] {\n  font-size: 22px;\n  font-weight: 700;\n  padding: 20px;\n  border-bottom: solid thin #ccc;\n}\n.card-header-title[data-v-f078e050] {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.tab-contents[data-v-f078e050] {\n  padding: 4px;\n  overflow-y: auto;\n  height: auto;\n}\n.item-name[data-v-f078e050] {\n  width: 160px;\n}\n.disp-scroll[data-v-f078e050]::-webkit-scrollbar {\n  width: 15px !important;\n  height: 15px !important;\n  visibility: visible !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f078e050","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/DashBoard/Manage/ModalActionCheck.vue
// module id = eh8N
// module chunks = 3